"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var Input_1 = __importDefault(require("../Input"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ContainerWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  z-index: 8;\n"], ["\n  position: relative;\n  width: 100%;\n  z-index: 8;\n"])));
var Items = styled_components_1.default.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 6;\n  max-height: ", ";\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid ", ";\n  border-radius: ", ";\n"], ["\n  position: absolute;\n  z-index: 6;\n  max-height: ", ";\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid ", ";\n  border-radius: ", ";\n"])), polished_1.rem(300), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
});
var StyledInput = styled_components_1.default(Input_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Item = styled_components_1.default('li')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", ";\n  display: flex;\n  width: 100%;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  min-height: ", ";\n  flex-shrink: 0;\n  padding: 0 ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  background-color: #fff;\n  ", ";\n"], ["\n  font-size: ", ";\n  display: flex;\n  width: 100%;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  min-height: ", ";\n  flex-shrink: 0;\n  padding: 0 ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  background-color: #fff;\n  ",
    ";\n"])), polished_1.em(14), polished_1.em(32), function (_a) {
    var theme = _a.theme;
    return polished_1.em(theme.grid.gutterWidth);
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    if (active) {
        return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        background-color: ", ";\n        color: ", ";\n      "], ["\n        background-color: ", ";\n        color: ", ";\n      "])), theme.color.primaryBg, theme.color.primary);
    }
    return '';
});
var ItemLabel = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])));
var InputAutocomplete = /** @class */ (function (_super) {
    __extends(InputAutocomplete, _super);
    function InputAutocomplete(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function () {
            _this.selectItem(-1);
        };
        _this.state = {
            focused: false,
            focusItemIndex: -1,
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.renderItem = _this.renderItem.bind(_this);
        _this.selectItem = _this.selectItem.bind(_this);
        _this.inputEl = null;
        console.warn('InputAutocomplete is DEPRECATED. Use TheSelect instead.');
        return _this;
    }
    /**
     * Soon to be deprecated in favor of TheSelect
     */
    InputAutocomplete.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.items !== this.props.items) {
            this.setState({ focusItemIndex: -1 });
        }
    };
    InputAutocomplete.prototype.handleFocus = function () {
        var onFocus = this.props.onFocus;
        if (onFocus) {
            onFocus();
        }
        this.setState({ focused: true, focusItemIndex: -1 });
    };
    InputAutocomplete.prototype.handleBlur = function () {
        var onBlur = this.props.onBlur;
        if (onBlur) {
            onBlur();
        }
        this.setState({ focused: false });
    };
    InputAutocomplete.prototype.handleKeyDown = function (event) {
        var items = this.props.items;
        var focusItemIndex = this.state.focusItemIndex;
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.setState({
                focusItemIndex: (focusItemIndex + 1) % items.length,
            });
        }
        else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.setState({
                focusItemIndex: (focusItemIndex + items.length - 1) % items.length,
            });
        }
        else if (event.key === 'Enter') {
            this.selectItem(focusItemIndex);
        }
        else if (event.key === 'Escape') {
            this.inputEl.blur();
        }
    };
    InputAutocomplete.prototype.handleChange = function (e) {
        this.props.onChange(e.target.value);
    };
    InputAutocomplete.prototype.selectItem = function (idx) {
        var _a = this.props, onSelectItem = _a.onSelectItem, items = _a.items;
        var value = idx in items ? items[idx] : null;
        if (onSelectItem(value) !== false) {
            this.inputEl.blur();
        }
    };
    InputAutocomplete.prototype.renderItem = function (item, idx) {
        var _this = this;
        var getItemLabel = this.props.getItemLabel;
        var focusItemIndex = this.state.focusItemIndex;
        var label = null;
        if (typeof item === 'string') {
            label = item;
        }
        else if (typeof getItemLabel === 'function') {
            label = getItemLabel(item);
        }
        else {
            throw Error('Invalid item. Supply either string, or define getItemLabel() function');
        }
        return (React.createElement(Item, { key: idx, active: idx === focusItemIndex, onMouseDown: function (e) {
                e.preventDefault();
                _this.selectItem(idx);
            }, onMouseEnter: function () {
                _this.setState({ focusItemIndex: idx });
            } },
            React.createElement(ItemLabel, null, label)));
    };
    InputAutocomplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, valid = _a.valid, items = _a.items, disabled = _a.disabled, submitAllowed = _a.submitAllowed, onSelectItem = _a.onSelectItem, getItemLabel = _a.getItemLabel, loading = _a.loading, inputProps = __rest(_a, ["valid", "items", "disabled", "submitAllowed", "onSelectItem", "getItemLabel", "loading"]);
        return (React.createElement(Wrapper, null,
            React.createElement(StyledInput, __assign({}, inputProps, { onChange: this.handleChange, onFocus: this.handleFocus, onBlur: this.handleBlur, disabled: disabled, onKeyDown: this.handleKeyDown, inputRef: function (el) {
                    _this.inputEl = el;
                }, autoComplete: "off" }),
                React.createElement("input", null),
                loading && React.createElement(Input_1.default.Loading, null),
                submitAllowed && (React.createElement(Input_1.default.Button, { primary: true, icon: "check", onClick: this.handleSubmit, disabled: !valid || disabled }))),
            React.createElement(ContainerWrapper, null, (this.state.focused || this.state.mouseDownOnItem) &&
                !!items &&
                items.length > 0 && React.createElement(Items, null, items.map(this.renderItem)))));
    };
    InputAutocomplete.propTypes = {
        valid: PropTypes.bool,
        items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])).isRequired,
        onSelectItem: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        getItemLabel: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        disabled: PropTypes.bool,
        submitAllowed: PropTypes.bool,
        loading: PropTypes.bool,
    };
    InputAutocomplete.defaultProps = {
        valid: true,
        onSelectItem: function () { },
        getItemLabel: null,
        onBlur: null,
        onFocus: null,
        disabled: false,
        submitAllowed: false,
        loading: false,
    };
    return InputAutocomplete;
}(React.Component));
exports.default = InputAutocomplete;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
